import React from "react";
import {NavLink, withRouter} from "react-router-dom";
import s from "../dialogs/MyPosts.module.css";



const MyContainer = () => {
    return (
        <div>
            <h4>Личный кабинет</h4>
            <NavLink to='/dialogs' activeClassName={s.active}><span>Мои сообщения</span></NavLink>
            <NavLink to='/favorites' activeClassName={s.active}><span>Избранное</span></NavLink>
        </div>

    )
}



export default withRouter(MyContainer)
